export default [
    {
        path: 'credit-salesman',
        name: 'creditSalesman',
        meta: {
            isDynamic: true,
            id: '授信业务员查询',
            inTab: true
        },
        component: () => import('@/views/creditManage/salesman')
    },
    {
        path: 'credit-cust',
        name: 'creditCust',
        meta: {
            isDynamic: true,
            id: '授信客户查询',
            inTab: true
        },
        component: () => import('@/views/creditManage/cust')
    },
    {
        path: 'credit-audit',
        name: 'creditAudit',
        meta: {
            isDynamic: true,
            id: '回款审核',
            inTab: true
        },
        component: () => import('@/views/creditManage/audit')
    },
    {
        path: 'credit-payconfig',
        name: 'creditPayconfig',
        meta: {
            isDynamic: true,
            id: '回款支付设置',
            inTab: true
        },
        component: () => import('@/views/creditManage/payconfig')
    },
    {
        path: 'credit-record',
        name: 'creditRecord',
        meta: {
            isDynamic: true,
            id: '回款记录',
            inTab: true
        },
        component: () => import('@/views/creditManage/record')
    }
]